import {enumType} from '../common/enumType';

export const RecurrenceType = enumType({
   SECONDS: {id: 'SECONDS', name: 'Seconds', noun: 'Seconds'},
   MINUTES: {id: 'MINUTES', name: 'Minutes', noun: 'Minutes'},
   HOURS: {id: 'HOURS', name: 'Hours', noun: 'Hours'},
   DAILY: {id: 'DAILY', name: 'Daily', noun: 'Days'},
   WEEKLY: {id: 'WEEKLY', name: 'Weekly', noun: 'Weeks'},
   MONTHLY: {id: 'MONTHLY', name: 'Monthly', noun: 'Months'},
});
